import * as types from '../../constants/rmg/CategoryActionTypes'
import {env} from '../../constants/Environment';
import {url} from '../../constants/rmg/settings';
import _ from 'lodash';

export function load(sportId){
	return async function(dispatch){
        dispatch({
            type: types.REQUEST,
            id: sportId
        });

        const response = await fetch(url + '/sports/' + sportId + '/categories');
        const result = await response.json();

        dispatch({
            type: types.RECEIVE,
            data: result.categories,
            id: sportId
        })
    }
}